export enum EPeopleDetailsTabsInUrl {
  DETAILS = 'details',
  NOTES = 'notes',
  OUTPUT = 'output',
}
